export const authConfig = {
  audience: process.env.REACT_APP_AUTH0_AUDIENCE || '',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || '',
  connection: 'Username-Password-Authentication',
  domain: process.env.REACT_APP_AUTH0_DOMAIN || '',
  grantType: 'password',
  redirectUri: window.location.origin,
  scope: 'openid profile email offline_access',
  responseType: 'id_token token',
};
